import React from 'react'
import FlexboxChallenge from './FlexboxChallenge'

export default class extends React.Component {
  render() {
    const literalStyles = `
      .no-cheating, .flexbox-challenge {
        height: 500px;
      }

      .no-cheating > *, .flexbox-challenge > *{
        margin: 10px;
        width: 200px;
        height: 200px;
      }

      .no-cheating {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-content: center;
        justify-content: center;
      }

      .flexbox-challenge {
        display: flex;
        flex-wrap: FFFRRRRRRRG;
        flex-direction: GARRRP;
        align-content: GRRRRRRREEEK;
        justify-content: SSSSNNNNRRRG;
      }
    `

    return (
      <FlexboxChallenge
        title="Flexbox Devtools Challenge"
        description="Fix the Flexbox layout using just the devtools!"
        literalStyles={literalStyles}
        nextChallenge={11}
      >
        <div />
        <div />
        <div />
        <div />
        <div />
      </FlexboxChallenge>
    )
  }
}
